/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum AzureSubscriptionType {
    Azure_CSP_Direct = 'Azure_CSP-Direct',
    Enterprise = 'Enterprise',
    Pay_as_You_Go = 'Pay_as_You_Go',
    Azure_Sponsorship = 'Azure_Sponsorship',
    Microsoft_Customer_Agreement = 'Microsoft_Customer_Agreement',
    Azure_CSP_InDirect = 'Azure_CSP-InDirect'
}
